module.exports = __webpack_public_path__ + "8ed0e58c4d8bf343c8e72233db2de4c9.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/modals/confirm-delete/confirm-delete.html
// module id = 1160
// module chunks = 0